<template>
    <div :show="dismissCountDown">
        <b-alert
        :show="dismissCountDown"
        dismissible
        :variant="message.variant"
        @dismissed="dismissCountDown=0"
        @dismiss-count-down="countDownChanged"
        >
        <p>{{ message.msg }}</p>
        <b-progress
            :variant="message.variant"
            :max="message.dismiss"
            :value="dismissCountDown"
            height="3px"
        ></b-progress>
        </b-alert>
    </div>
</template>

<script>
export default {
    name: 'Message',
    props: {
        message: Object
    },
    data() {
      return {
        dismissCountDown: 0
      }
    },
    methods: {
      countDownChanged(dismissCountDown) {
        this.dismissCountDown = dismissCountDown;
      },
    },
    mounted: function() {
        var vm = this;
        this.$watch('message', message => {
            vm.message = message;
            vm.dismissCountDown = message.dismiss;
        });
    }
}
</script>